import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "../components/Reveal";
import { PRODUCTIONS } from "../data/content";

export default function FeaturedProductions() {
  return (
    <section data-testid="productions-section" className="relative w-full bg-[#050505]">
      <div className="pad-x pb-10 pt-24 md:pt-32">
        <Reveal>
          <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
            <div>
              <span className="overline">Featured Work</span>
              <h2 className="display-title mt-3 text-white">Selected<br className="hidden md:block" /> Productions</h2>
            </div>
            <Link to="/productions" data-testid="view-all-productions" className="text-sm uppercase tracking-[0.15em] text-neutral-300 transition-colors hover:text-gold">
              All work →
            </Link>
          </div>
        </Reveal>
      </div>

      {/* AWAL-style editorial horizontal gallery — flat strips, partial crop at right edge */}
      <Reveal>
        <div
          data-testid="productions-strip"
          className="no-scrollbar flex snap-x snap-mandatory gap-3 overflow-x-auto pb-24 pl-[clamp(24px,5vw,80px)] pr-6 [scroll-padding-left:clamp(24px,5vw,80px)] md:gap-4 md:pb-32"
        >
          {PRODUCTIONS.map((p, i) => (
            <Link
              key={p.title}
              to="/productions"
              data-testid={`production-card-${i}`}
              className="group relative block aspect-[2/3] w-[540px] max-w-[80vw] flex-none snap-start overflow-hidden bg-[#0a0a0a]"
            >
              <img
                src={p.image}
                alt={p.title}
                loading={i > 2 ? "lazy" : undefined}
                style={{ objectPosition: p.imgPos || "center" }}
                className="h-full w-full object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent transition-opacity duration-500" />
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-7">
                <span className="text-[0.65rem] uppercase tracking-[0.22em] text-white/60 transition-colors duration-300 group-hover:text-gold">
                  {p.category} · {p.year}
                </span>
                <h3 className="mt-2 font-playfair text-2xl font-bold leading-tight text-white md:text-[1.7rem]">
                  {p.title}
                </h3>
                <span className="mt-3 inline-flex translate-y-1 items-center gap-1.5 text-[0.7rem] uppercase tracking-[0.2em] text-white/70 opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                  View Project <ArrowUpRight size={13} />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </Reveal>
    </section>
  );
}
